import { required } from "@vuelidate/validators";
const obirimbelge = {
  data() {
    return {
      obirimbelgeData: {
        Baslik: null,
        Dosyayolu: null,
        Olusturanid: null,
        Birimid: null,
      },
      FormDataType: {
        Baslik: { FieldName: "Baslik", Field: "input", FieldTitle: "Başlık" },
        Dosyayolu: { FieldName: "Dosyayolu", Field: "input", FieldTitle: "Dosya Yolu" },
        Birimid: { FieldName: "Birimid", Field: "combobox", FieldTitle: "Birim", ComboData: {}, ComboDataArray: [], Multiple: false },

      }

    }
  },
  validations: {
    FormData: {
      Baslik: { required },
      Dosyayolu: {},
      Olusturanid: {},
      Birimid: {},
    }
  },


  created() {
    this.ActionsFilterGet({ Service: "obirim/gettree", FullData: true, Filter: "" }).then((res) => {
      this.FormDataType.Birimid.ComboDataArray = res.Data
    });

  }
}
export default obirimbelge